import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiService from '../services/api';

const TrainerPaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    const processPayment = async () => {
      const trainerId = searchParams.get('trainer_id');
      const paymentSuccess = searchParams.get('payment') === 'success';

      // Always show the success modal immediately if payment=success
      // This provides immediate feedback while verification happens in background
      if (paymentSuccess) {
        setShowSuccessModal(true);
        setLoading(false);
      }

      if (!trainerId) {
        console.warn('No trainer_id found in URL');
        return;
      }

      // Verify payment in background (non-blocking)
      try {
        console.log('Verifying trainer registration payment for trainer_id:', trainerId);
        const verifyResponse = await apiService.verifyTrainerRegistrationPayment({
          trainer_id: trainerId
        });

        console.log('Trainer payment verification response:', verifyResponse);

        if (verifyResponse.Code !== 200 || verifyResponse.payment_status !== 'completed') {
          console.warn('Payment verification returned:', verifyResponse);
          // If verification fails, we still show success since payment likely went through
        }
      } catch (err) {
        console.error('Error verifying trainer payment:', err);
        // Don't change UI on verification error - payment likely succeeded
      }
    };

    processPayment();
  }, [searchParams]);

  const handleClose = () => {
    setShowSuccessModal(false);
    // Redirect to home page after closing
    navigate('/');
  };

  const styles = {
    container: {
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modalContent: {
      background: 'white',
      borderRadius: '20px',
      padding: '40px',
      maxWidth: '500px',
      width: '100%',
      textAlign: 'center',
      boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      position: 'relative'
    },
    logo: {
      fontSize: '3rem',
      marginBottom: '20px'
    },
    logoText: {
      fontSize: '2rem',
      fontWeight: '700',
      marginBottom: '30px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text'
    },
    successIcon: {
      fontSize: '4rem',
      marginBottom: '20px',
      color: '#27ae60'
    },
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      marginBottom: '15px',
      color: '#2c3e50'
    },
    message: {
      fontSize: '1.1rem',
      marginBottom: '30px',
      color: '#7f8c8d',
      lineHeight: '1.6'
    },
    button: {
      padding: '12px 30px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1rem',
      cursor: 'pointer',
      fontWeight: '600',
      transition: 'transform 0.2s',
      marginTop: '10px'
    },
    loading: {
      color: 'white',
      fontSize: '1.2rem'
    }
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>Processing payment...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {showSuccessModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div style={styles.logo}>🐾</div>
            <div style={styles.logoText}>Pheefee</div>
            <div style={styles.successIcon}>✅</div>
            <h1 style={styles.title}>Payment Successful!</h1>
            <p style={styles.message}>
              Payment successful. We will process your application and get back to you shortly.
            </p>
            <button
              onClick={handleClose}
              style={styles.button}
              onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainerPaymentSuccess;

